export default {
    TextPlaceholder: 'Please input your approval opinion',
    SettingTips: 'Set to common review',
    SelectPlaceholder: 'Click on the select',
    UploadTitle: 'Click or drag to upload',
    OverSize: 'Over the limit size',
    OverNum: 'Over the limit quantity',
    success: 'file uploaded successfully',
    error: 'file upload failed.'
};
